<template>
  <b-container
    fluid
    class="h-100-trim-header-footer padding-none"
    id="tailieWidget"
  >
    <img
      class="d-md-none pt-3 d-block mw-100 m-auto"
      style="max-height:50%"
      :src="imageLink"
    />
    <h1 class="mt-md-3 text-center text-md-left">
      {{ $t("login-main-title") }}
    </h1>
    <p class="mt-md-5 mt-2 text-center text-md-left">
      {{ $t("login-sub-title") }}
    </p>
    <b-row class="mt-5">
      <b-col md="5" class="col-md-5 col pr-1 ">
        <b-button
          @click="$router.push({ name: 'login-app' })"
          class="border-black border-bold font-weight-bold w-100  bg-white text-black mr-2 shadow-none"
        >
          {{ $t("login") }}
        </b-button>
      </b-col>
      <b-col class="col-md-5 col pl-1">
        <b-button
          @click="$router.push({ name: 'login-try-now' })"
          class="bg-black w-100 text-white border border-black shadow-none"
        >
          {{ $t("login-try-it-now") }}
        </b-button>
      </b-col>
    </b-row>
    <div
      class="text-black mt-4 padding-none text-center text-md-left"
      @click="$router.push({ name: 'login-video' })"
    >
      <Play class="mr-1" />
      <u>{{ $t("login-how-does-it-work") }} </u>
    </div>
    <b-row class="mt-5 benefits-row">
      <b-col class="col-12 col-sm-4 w1-3 padding-none text-center text-md-left">
        <b-row class="justify-content-center">
          <b-col class="col-auto">
            <ShirtSvg class="benefit-icon" />
          </b-col>
          <b-col class="mt-1 col-auto">
            <p class="benefits-text">{{ $t("login-benefit-1") }}</p>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="col-12 col-sm-4 w1-3 padding-none text-center text-md-left">
        <b-row class="justify-content-center">
          <b-col class="col-auto">
            <TruckSvg class="benefit-icon" />
          </b-col>
          <b-col class="mt-1 col-auto">
            <p class="benefits-text">{{ $t("login-benefit-2") }}</p>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="col-12 col-sm-4 w1-3 padding-none text-center text-md-left">
        <b-row class="justify-content-center">
          <b-col class="col-auto">
            <LeafSvg class="benefit-icon" />
          </b-col>
          <b-col class="col-auto mt-1">
            <p class="benefits-text">{{ $t("login-benefit-3") }}</p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import ShirtSvg from "../../assets/images/Shirtje.svg";
import TruckSvg from "../../assets/images/Vrachtwagen.svg";
import LeafSvg from "../../assets/images/Plantje.svg";
import Play from "../../assets/images/play.svg";
import { mapGetters } from "vuex";

export default {
  name: "login",
  components: {
    ShirtSvg,
    Play,
    TruckSvg,
    LeafSvg
  },
  computed: {
    ...mapGetters({
      imageLink: "pageParams/getImageLink"
    })
  },
  created() {
    this.$gtag.event("login", { method: "Google" });
  }
};
</script>
<style scoped>
.border-bold {
  border: 2px solid;
}

.benefits-row {
  margin-top: 5rem !important;
  margin-bottom: 3rem !important;
}

/* .benefits-row {
  position: absolute;
  width: 100%;
  bottom: 105px;
} */
.benefit-icon {
  margin-top: 11px;
}

.benefits-text {
  width: 90px;
  font-size: smaller;
  color: #bdbdbd;
  font-weight: bold;
  /* width: 80px; */
}
</style>
